<template>
  <div>
    <b-modal
      id="modal-role"
      ref="my-modal"
      cancel-variant="outline-secondary"
      ok-title="Save"
      :ok-disabled="user_type === 'super-admin'"
      cancel-title="Close"
      centered
      :title="$t('DEBTIA_STATEMENET_GROUP')"
      size="lg"
      no-close-on-backdrop
      @ok="submitHandler"
    >
      <b-overlay
        id="overlay-background"
        :show="modalLoads === true"
        variant="dark"
        opacity="0.85"
        blur="2px"
        rounded="sm"
        spinner-variant="primary"
        spinner-medium
      >
        <b-alert
          v-if="errorMsg"
          variant="warning"
          show
        >
          <h4 class="alert-heading">
            {{ $t('DEBITA_ERROR') }}
          </h4>
          <div class="alert-body">
            <span>{{ errorMsg }}</span>
          </div>
        </b-alert>
        <b-form>
          <validation-observer
            ref="statementGroupForm"
            tag="form"
          >
            <b-row>
              <b-col
                sm="6"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Title"
                  rules="required"
                >
                  <b-form-group
                    :label="$t('DEBTIA_TITLE')"
                    label-for="title"
                    class="mb-2"
                  >
                    <b-form-input
                      id="title"
                      v-model="details.title"
                      type="text"
                      :placeholder="$t('DEBTIA_TITLE')"
                      :readonly="user_type === 'super-admin'"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <b-col
                sm="6"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Danish Title"
                  rules="required"
                >
                  <b-form-group
                    :label="$t('DEBTIA_DA_TITLE')"
                    label-for="da_name"
                    class="mb-2"
                  >
                    <b-form-input
                      id="da_name"
                      v-model="details.da_name"
                      type="text"
                      :placeholder="$t('DEBTIA_DA_TITLE')"
                      :readonly="user_type === 'super-admin'"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>

                  </b-form-group>
                </validation-provider>
              </b-col>

              <b-col
                sm="6"
              >
                <validation-provider
                  #default="{ errors }"
                  name="English Title"
                  rules="required"
                >
                  <b-form-group
                    :label="$t('DEBTIA_EN_TITLE')"
                    label-for="en_name"
                    class="mb-2"
                  >
                    <b-form-input
                      id="title"
                      v-model="details.en_name"
                      type="text"
                      :placeholder="$t('DEBTIA_EN_TITLE')"
                      :readonly="user_type === 'super-admin'"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <b-col
                sm="6"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Statements"
                  rules="required"
                >
                  <b-form-group
                    :label="$t('DEBTIA_STATEMENTS')"
                    label-for="statement_ids"
                    style="margin-bottom: 0px"
                  >
                    <v-select
                      v-model="details.statement_ids"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="getStatementGroupsOptions"
                      :reduce="val => val.value"
                      required
                      multiple
                    />
                  </b-form-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-col>
              <b-col sm="2">
                <validation-provider
                  #default="{ errors }"
                  name="Status"
                  rules="required"
                >
                  <b-form-group
                    :label="$t('DEBTIA_STATUS')"
                    label-for="status"
                  >
                    <b-form-checkbox
                      v-model="details.status"
                      class="mr-0 mt-50"
                      name="is-rtl"
                      switch
                      inline
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
            </b-row>
          </validation-observer>
        </b-form>
      </b-overlay>
    </b-modal>
  </div>
</template>

<script>
import {
  BRow, BCol, BFormGroup, BFormInput, BForm, BOverlay, BFormCheckbox, BAlert,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import axios from '@axios'
import constants from '@/app-configs/constants'
import vSelect from 'vue-select'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    BOverlay,
    vSelect,
    BFormCheckbox,
    BAlert,
  },
  directives: {
    Ripple,
  },
  props: {
    getStatementGroupsData: {
      type: Object,
      required: true,
    },
    getStatementGroupsOptions: {
      type: Array,
      required: true,
    },
    getStatementIds: {
      type: Array,
      required: true,
    },
    reloadMethod: {
      type: Function,
      required: true,
    },
    modalLoads: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      snowOption: {
        theme: 'snow',
      },
      required,
      details: {},
      statementId: [],
      statementIds: [],
      reservedStatementIds: [],
      user_type: JSON.parse(localStorage.getItem('userData')).data.user_type,
      errorMsg: '',
    }
  },
  watch: {
    getStatementGroupsData: {
      handler() {
        this.reservedStatementIds = []
        this.details = { ...this.getStatementGroupsData }
        if (this.details.status === 1) {
          this.details.status = true
        } else {
          this.details.status = false
        }
        if (this.details.statement_ids === '') {
          this.details.statement_ids = []
        } else {
          this.details.statement_ids = JSON.parse(this.details.statement_ids)
          this.details.statement_ids.forEach(element => {
            if (this.getStatementIds.includes(element) === false) {
              this.reservedStatementIds.push(element)
            }
          })
          this.reservedStatementIds.forEach(element => {
            const index = this.details.statement_ids.indexOf(element)
            if (index !== -1) {
              this.details.statement_ids.splice(index, 1)
            }
          })
        }
      },
    },
  },
  methods: {
    submitHandler(evt) {
      evt.preventDefault()
      this.$refs.statementGroupForm.validate().then(success => {
        if (success) {
          this.modalLoads = true
          let url = ''
          if (this.details.id > 0) {
            url = `${constants.baseUrl}/edit-statement-group`
            this.details.statement_ids = [...this.details.statement_ids, ...this.reservedStatementIds]
          } else {
            url = `${constants.baseUrl}/add-statement-group`
          }
          axios.post(url, { ...this.details }).then(response => {
            this.errorMsg = ''
            this.modalLoads = false
            if (response.status === 200) {
              this.$nextTick(() => {
                this.$refs['my-modal'].toggle('#toggle-btn')
              })
              this.details = {
                id: 0, title: '', da_name: '', en_name: '', statement_ids: [], user_id: JSON.parse(localStorage.getItem('userData')).data.id,
              }
              this.reloadMethod()
            }
          }).catch(err => {
            if (err.response.data.message) {
              const msg = err.response.data.message
              this.errorMsg = msg
              this.modalLoads = false
            }
          })
        }
      })
    },
  },
}
</script>

<style lang="scss">

</style>
